/**
 * 仪表盘 · 指导销售 — 0418 批量挂卖入口（与数据看板卡片同一组件）。
 */
import { Typography } from 'antd';
import { GuideSalesOpsCard } from '../../components/GuideSalesOpsCard';

export function GuideSalesPage() {
  return (
    <div>
      <Typography.Title level={4} style={{ marginTop: 0 }}>
        指导销售
      </Typography.Title>
      <GuideSalesOpsCard variant="card" includeSplitPreview />
    </div>
  );
}

export default GuideSalesPage;
